export const localDate = (date) => {
  return new Date(date.replace(/-/g, '/')).toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' })
}
